import type { ReactElement } from "react";

import { cn } from "~/lib/utils";

export const MaskedPhoneRow = ({ className, actions }: { className?: string; actions?: ReactElement | null }) => (
  <div className={cn("group flex h-7 items-center gap-3", className)}>
    <span className="w-12 font-normal text-xs">Phone</span>
    <div className="flex min-w-0 flex-1 items-center gap-1 overflow-hidden">
      <span className="type-xs min-w-0 truncate text-text-tertiary">
        <span aria-hidden="true">(###) ###-####</span>
        <span className="sr-only">withheld</span>
      </span>
      {actions ? (
        <span className="flex flex-none items-center gap-0.5 transition-opacity md:opacity-0 md:group-hover:opacity-100">
          {actions}
        </span>
      ) : null}
    </div>
  </div>
);
